<template>
  <div class="vimeo-player">
    <div ref="player"></div>
  </div>
</template>

<script>
import Player from '@vimeo/player'

export default {
  name: 'LearningVideo',
  // components: {
  //   Player,
  // },
  props: {
    videoId: String // The Vimeo video ID
    // accessToken: String,
  },
  mounted () {
    const options = {
      id: this.videoId,
      width: 640, // Set the desired width
      loop: false,
      autoplay: false,
      byline: false,
      title: false,
      portrait: false,
      fullscreen: true,
      transparent: false // Add this option to disable the transparent player background
    }

    this.player = new Player(this.$refs.player, options)
  },
  beforeDestroy () {
    this.player.destroy()
  }
}
</script>

<style scoped>
.vimeo-player {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  overflow: hidden;
  max-width: 100%;
  height: 0;
}

.vimeo-player iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
